import { withBase } from 'ufo';
import chatConfig from '~~/configs/chat.config';

export default function useEazyChat() {
  const initialized = ref<boolean>(false);

  let _additionalConfig = {};
  let _className: string | undefined;

  const load = async () => {
    const baseURL = useRuntimeConfig().app.baseURL || '/';
    const finalConfig: object = {
      ...chatConfig,
      businessIconUrl: withBase(chatConfig.businessIconUrl, baseURL),
      buttonIconUrl: withBase(chatConfig.buttonIconUrl, baseURL),
      ..._additionalConfig,
    };

    window.Eazy.init(finalConfig)
      .then(() => {
        nextTick(() => {
          const iFrame = document.querySelector('#web-messenger-container') as HTMLIFrameElement;
          if (_className) {
            iFrame.classList.add(_className);
          }
          iFrame.title = 'EenVandaag Chat';

          initialized.value = true;
        });
      })
      .catch(console.error);

    if (finalConfig.embedId) {
      window.Eazy.render(document.getElementById(finalConfig.embedId));
    }
  };

  const initialize = (additionalConfig?: object, className?: string) => {
    _additionalConfig = additionalConfig || {};
    _className = className;

    nextTick(() => {
      if (window.Eazy) {
        destroy();
        load();
      } else {
        useHead({
          script: [
            {
              src: '/scripts/chat.js', // External script
              async: true,
              defer: true,
              onload: load,
            },
          ],
        });
      }
    });
  };

  const destroy = () => {
    if (window.Eazy) {
      window.Eazy.destroy();
      initialized.value = false;
    }
  };

  return { initialized, initialize };
}
